import React, { useEffect, useMemo, useState } from 'react';
import PaginationComponent from 'components/util/paginacao/.mixins/paginacao';

export const usePagination = () => {
  const [nextRows, setNextRows] = useState(5);
  const [totalRows, setTotalRows] = useState(0);
  const nextRowsOptions = [5, 10, 25, 50, 100];
  const [initialRow, setInitialRow] = useState(0);

  useEffect(() => {
    setInitialRow(0);
  }, [nextRows]);

  const onChangePage = (pageFrom: number) => setInitialRow(pageFrom);

  const clearPagination = () => {
    setInitialRow(0);
    setNextRows(5);
  };

  const Pagination = useMemo(() => {
    // eslint-disable-next-line react/display-name
    return () => (
      <PaginationComponent
        rowsPerPage={nextRows}
        totalRows={totalRows}
        rowsPerPageOptions={nextRowsOptions}
        onChangePage={onChangePage}
        setRowsPerPage={setNextRows}
      />
    );
  }, [nextRows, totalRows]);

  return { Pagination, nextRows, initialRow, setTotalRows, clearPagination };
};
